import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { adminServices } from "../services/AdminServices";

const EditPOModal = ({ isOpen, poDetails, orderDetails, onClose, onSaveDraft, onFinalize }) => {
  const [updatedPO, setUpdatedPO] = useState(poDetails);
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  

  useEffect(() => {
    if (poDetails) {
      console.log("PO details loaded into modal:", poDetails, orderDetails);
      setUpdatedPO(poDetails);
      setEditingRowIndex(null);
    }
  }, [poDetails, isOpen]);

  if (!isOpen || !updatedPO) {
    return null;
  }

  const handlePriceChange = (index, newPrice) => {
    const updatedItems = updatedPO.items.map((item, i) =>
      i === index
        ? { ...item, price: parseFloat(newPrice) || 0, unitPrice: parseFloat(newPrice) || 0 }
        : item
    );
    setUpdatedPO({ ...updatedPO, items: updatedItems });
  };

  const handleQtyChange = (index, newQty) => {
    const updatedItems = updatedPO.items.map((item, i) =>
      i === index
        ? { ...item, quantity: parseInt(newQty) || 0, qty: parseInt(newQty) || 0 }
        : item
    );
    setUpdatedPO({ ...updatedPO, items: updatedItems });
  };

  const handleEditRow = (index) => {
    setEditingRowIndex(index);
  };

  const handleSaveItem = async (index) => {
    try {
      const item = updatedPO.items[index];
      const orderId = orderDetails?.order?.orderId;
      
      if (!orderId) {
        toast.error("Order ID not found");
        return;
      }

      const requestBody = {
        purchaseOrderId: poDetails.poNo,
        supplierId: item.supplierId,
        supplierInventoryId: item.supplierInventoryId,
        productId: item.productId,
        uomId: item.uomId,
        price: item.price || item.unitPrice || 0,
        quantity: item.quantity || item.qty || 0,
        remarks: item.remarks || "",
      };

      const endpoint = `IpxPurchaseOrders/item/update/${orderId}`;
      const response = await adminServices.updateData(endpoint, requestBody);

      //console.log("Item updated successfully:", response.data);
      toast.success("Item updated successfully");
      setEditingRowIndex(null);
    } catch (error) {
      console.error("Error saving item:", error);
      toast.error("Error updating item: " + (error.response?.data?.message || error.message));
    }
  };

  const handleRemarksChange = (newRemarks) => {
    setUpdatedPO({ ...updatedPO, remarks: newRemarks });
  };

  const handleSaveDraft = async () => {
    try {
      ////console.log("Saving draft with data:", updatedPO);
      await onSaveDraft(updatedPO);
      onClose();
    } catch (error) {
      console.error("Error saving draft:", error);
    }
  };

  const handleFinalize = async () => {
    try {
      await onFinalize(updatedPO);
      onClose();
    } catch (error) {
      console.error("Error finalizing PO:", error);
    }
  };

  const calculateTotal = () => {
    return (updatedPO.items || []).reduce(
      (sum, item) => sum + ((item.price || item.unitPrice || 0) * (item.quantity || item.qty || 0)),
      0
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        overflow: "auto",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: 8,
          padding: 32,
          maxWidth: 1000,
          width: "90%",
          maxHeight: "90vh",
          overflow: "auto",
          boxShadow: "0 20px 25px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 700 }}>Edit Purchase Order</h2>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer" }}
          >
            ×
          </button>
        </div>

        {/* PO Header Info */}
        <div style={{ backgroundColor: "#f3f4f6", padding: 16, borderRadius: 8, marginBottom: 24 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>PO No.</label>
              <input
                type="text"
                value={updatedPO.poNo}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>PR No.</label>
              <input
                type="text"
                value={updatedPO.prNo}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Supplier Name</label>
              <input
                type="text"
                value={updatedPO.supplierName}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Date Issued</label>
              <input
                type="text"
                value={updatedPO.dateIssued}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Address</label>
              <input
                type="text"
                value={updatedPO.address}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Contact Person</label>
              <input
                type="text"
                value={updatedPO.contactPerson}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Expected Delivery Date</label>
              <input
                type="text"
                value={updatedPO.expectedDeliveryDate}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
            <div>
              <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Payment Terms</label>
              <input
                type="text"
                value={updatedPO.paymentTerms}
                readOnly
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div style={{ marginBottom: 24 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr style={{ backgroundColor: "#0F2A40", color: "#fff" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>No.</th>
                <th style={{ padding: "12px", textAlign: "left" }}>SKU</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Item Description</th>
                <th style={{ padding: "12px", textAlign: "center" }}>UOM</th>
                <th style={{ padding: "12px", textAlign: "center" }}>QTY</th>
                <th style={{ padding: "12px", textAlign: "right" }}>Unit Price</th>
                <th style={{ padding: "12px", textAlign: "right" }}>Total</th>
                <th style={{ padding: "12px", textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {updatedPO.items && updatedPO.items.length > 0 ? (
                updatedPO.items.map((item, idx) => {
                  const orderItem = orderDetails?.orderItems?.find((oi) => oi.productId === item.productId);
                  const sku = orderItem?.sku || item.sku || "-";
                  const productName = orderItem?.productName || item.description || item.productName || "-";
                  const uom = orderItem?.uomName || item.uom || "-";
                  const isEditing = editingRowIndex === idx;
                  return (
                    <tr key={idx} style={{ borderBottom: "1px solid #e5e7eb" }}>
                      <td style={{ padding: "12px" }}>{idx + 1}</td>
                      <td style={{ padding: "12px" }}>{sku}</td>
                      <td style={{ padding: "12px" }}>{productName}</td>
                      <td style={{ padding: "12px", textAlign: "center" }}>{uom}</td>
                      <td style={{ padding: "12px", textAlign: "center" }}>
                        {isEditing ? (
                          <input
                            type="number"
                            value={item.quantity || item.qty || 0}
                            onChange={(e) => handleQtyChange(idx, e.target.value)}
                            style={{
                              width: "100%",
                              padding: "8px",
                              border: "1px solid #0369a1",
                              borderRadius: 4,
                              textAlign: "center",
                            }}
                          />
                        ) : (
                          item.quantity || item.qty || 0
                        )}
                      </td>
                      <td style={{ padding: "12px", textAlign: "right" }}>
                        {isEditing ? (
                          <input
                            type="number"
                            value={item.price || item.unitPrice || 0}
                            onChange={(e) => handlePriceChange(idx, e.target.value)}
                            style={{
                              width: "100%",
                              padding: "8px",
                              border: "1px solid #0369a1",
                              borderRadius: 4,
                              textAlign: "right",
                            }}
                          />
                        ) : (
                          `₱${(item.price || item.unitPrice || 0).toFixed(2)}`
                        )}
                      </td>
                      <td style={{ padding: "12px", textAlign: "right" }}>
                        ₱{(
                          (item.price || item.unitPrice || 0) *
                          (item.quantity || item.qty || 0)
                        ).toFixed(2)}
                      </td>
                      <td style={{ padding: "12px", textAlign: "center" }}>
                        {isEditing ? (
                          <button
                            onClick={() => handleSaveItem(idx)}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "1.2rem",
                              color: "#10b981",
                              padding: "4px 8px",
                            }}
                            title="Save item"
                          >
                            ✓
                          </button>
                        ) : (
                          <button
                            onClick={() => handleEditRow(idx)}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              fontSize: "1rem",
                              color: "#0369a1",
                              padding: "4px 8px",
                            }}
                            title="Edit item"
                          >
                            ✏️
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    style={{ padding: "12px", textAlign: "center", color: "#6b7280" }}
                  >
                    No items
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Total */}
        <div style={{ textAlign: "right", marginBottom: 24, fontSize: "1.125rem", fontWeight: 700 }}>
          TOTAL: ₱{calculateTotal().toFixed(2)}
        </div>

        {/* Contact Info */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 16,
            marginBottom: 24,
            padding: 16,
            backgroundColor: "#f9fafb",
            borderRadius: 8,
          }}
        >
          <div>
            <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>
              Requested by
            </label>
            <div style={{ marginTop: 4, fontSize: "0.95rem" }}>{updatedPO.requestedBy}</div>
          </div>
          <div>
            <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Phone</label>
            <div style={{ marginTop: 4, fontSize: "0.95rem" }}>{updatedPO.phone}</div>
          </div>
          <div>
            <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500 }}>Email</label>
            <div style={{ marginTop: 4, fontSize: "0.95rem" }}>{updatedPO.email}</div>
          </div>
        </div>

        {/* Remarks */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: "0.875rem", color: "#6b7280", fontWeight: 500, display: "block", marginBottom: 8 }}>
            Remarks
          </label>
          <textarea
            value={updatedPO.remarks || updatedPO.poRemarks ||""}
            onChange={(e) => handleRemarksChange(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              border: "1px solid #e5e7eb",
              borderRadius: 4,
              minHeight: 100,
              fontFamily: "inherit",
            }}
            placeholder="Enter remarks..."
          />
        </div>

        {/* Action Buttons */}
        <div style={{ display: "flex", gap: 12, justifyContent: "flex-end" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              backgroundColor: "#f3f4f6",
              color: "#111827",
              border: "1px solid #d1d5db",
              borderRadius: 6,
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSaveDraft}
            disabled={editingRowIndex !== null}
            style={{
              padding: "10px 20px",
              backgroundColor: editingRowIndex !== null ? "#d1d5db" : "#0F2A40",
              color: editingRowIndex !== null ? "#6b7280" : "#fff",
              border: "none",
              borderRadius: 6,
              cursor: editingRowIndex !== null ? "not-allowed" : "pointer",
              fontWeight: 500,
            }}
          >
            Save as Draft
          </button>
          <button
            onClick={handleFinalize}
            disabled={editingRowIndex !== null}
            style={{
              padding: "10px 20px",
              backgroundColor: editingRowIndex !== null ? "#d1d5db" : "#0369a1",
              color: editingRowIndex !== null ? "#6b7280" : "#fff",
              border: "none",
              borderRadius: 6,
              cursor: editingRowIndex !== null ? "not-allowed" : "pointer",
              fontWeight: 500,
            }}
          >
            Finalize PO
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPOModal;
